module.exports = __webpack_public_path__ + "media/images/hero-mebel-271e6d95f724b5fcc68c0ff7765341b5.png";